<script lang="ts">
  import { Paragraph, Heading } from './components';
  import type { UseFormattedProps } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
</script>

<div class="clone-wrap" style="background-color:var(--vlt-lp-background)">
  <div class="hero-section wf-section" id={properties.anchor}>
    <div class="hero-content">
      <div
        class="inner-hero-content {properties.imageAlignment === 'left'
          ? 'reverse'
          : ''}"
        style="text-align: {properties.textAlignment}"
      >
        {#if properties.heading}
          <Heading
            type={'h2'}
            css={'margin-bottom:50px;color:var(--vlt-lp-text);'}
          >
            {@html properties.heading}
          </Heading>
        {/if}

        {#if properties.text}
          <Paragraph css={'color:var(--vlt-lp-text);'}>
            {@html properties.text}
          </Paragraph>
        {/if}

        {#if properties.button.active}
          <div class="button-wrapper">
            <a
              href={properties.button.link}
              class="secondary-button w-inline-block"
            >
              <div>{properties.button.label}</div>
              <img
                src="/right-arrow-1.svg"
                loading="lazy"
                alt=""
                class="right-arrow"
              />
            </a>
          </div>
        {/if}
      </div>
    </div>
    <div
      class="hero-image-wrap {properties.imageAlignment === 'left'
        ? 'reverse'
        : ''}"
      style="background: url({properties.image})"
    />
  </div>
</div>

<style>
  .clone-wrap {
    background-color: var(--vlt-lp-background, #fff);
    margin: 40px 0;
  }
  .inner-hero-content {
    display: flex;
    max-width: none;
    padding: 0 500px 0 40px;
    flex-direction: column;
    align-items: flex-start;
    border-style: none none none solid;
    border-width: 1px 1px 1px 5px;
    border-color: var(--vlt-lp-primary);
  }
  .reverse.inner-hero-content {
    padding: 0 40px 0 500px;
    border-style: none solid none none;
    border-width: 1px 5px 1px 1px;
    border-color: var(--vlt-lp-primary);
  }
  .reverse.hero-image-wrap {
    left: 0;
  }
  .button-wrapper {
    display: flex;
    margin-top: 20px;
    align-items: center;
  }

  .hero-image-wrap {
    position: absolute;
    left: auto;
    top: auto;
    right: 0;
    bottom: auto;
    width: 40vw;
    height: 400px;
    border-style: solid none solid solid;
    border-width: 1px;
    border-color: #dbdbdb;
    background-position: 50% 50%;
    background-size: cover;
  }

  .hero-section {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px none #dbdbdb;
  }

  .hero-content {
    display: flex;
    width: 100%;
    height: 400px;
    max-width: 1100px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .secondary-button {
    display: flex;
    margin-left: 25px;
    align-items: center;
    transition: all 200ms ease;
    color: #000;
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    text-decoration: none;
  }

  .secondary-button:hover {
    opacity: 0.8;
    transform: translate(5px, 0px);
  }

  .right-arrow {
    height: 15px;
    margin-top: 2px;
    margin-left: 7px;
  }

  @media screen and (max-width: 991px) {
    .inner-hero-content {
      padding-right: 0;
      padding-left: 0;
      border-left-style: none;
    }

    .hero-image-wrap {
      position: static;
      width: 100%;
    }

    .hero-content {
      padding-right: 20px;
      padding-left: 20px;
      align-items: center;
    }
  }

  @media screen and (max-width: 767px) {
    .hero-section {
      padding: 0 15px;
      flex-direction: column;
    }

    .hero-content {
      padding-right: 0;
      padding-bottom: 40px;
      padding-left: 0;
      height: auto;
    }
  }

  @media screen and (max-width: 479px) {
    .inner-hero-content {
      padding: 0;
    }

    .hero-image-wrap {
      height: 300px;
    }
  }
</style>
